import React from 'react';

import CN from './UseProductSearch.module.scss';

const UseProductSearch = ({ items, dropdown, label, error, ...extra }) => (
  <div data-bem="UseProductSearch" className={CN.container}>
    <span data-bem="UseProductSearch__label">{label}</span>
    <input {...extra} data-bem="UseProductSearch__input" className={CN.search} autoComplete="off" />
    <span className={CN.error}>{error}</span>
    {dropdown && (
      <div data-bem="UseProductSearch__list" className={CN.dropdown}>
        <ul>{items}</ul>
      </div>
    )}
  </div>
);

export default UseProductSearch;
